module.exports = __webpack_public_path__ + "static/media/Codex.370d616c.png";